@if (!isMobileRoute()) {
    <pims-global-header />
}
<router-outlet />
